import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateProfileData } from "../../storeSlices/profileSlice";
const ShowProfile = () => {
  const MyProfile = useSelector((state) => state.dataReducer.profile);

  const [editMode, setEditMode] = useState(false);
  const lastProfile = MyProfile?.pro;
  // MyProfile?.pro && MyProfile?.pro[MyProfile?.pro.length - 1];

  console.log(lastProfile);
  // const [profileData, setProfileData] = useState({
  //   name: MyProfile?.pro[0]?.name,
  //   address: MyProfile?.pro[0]?.address,
  //   gst_no: MyProfile?.pro[0]?.gst_no,
  //   pan_card: MyProfile?.pro[0]?.pan_card,
  //   phone_no: MyProfile?.pro[0]?.phone_no,
  //   createdby: MyProfile?.pro[0]?.createdby,
  // });
  const [profileData, setProfileData] = useState({
    name: lastProfile?.name,
    address: lastProfile?.address,
    gst_no: lastProfile?.gst_no,
    pan_card: lastProfile?.pan_card,
    phone_no: lastProfile?.phone_no,
    createdby: lastProfile?.createdby,
  });

  const dispatch = useDispatch();
  const handleEditClick = () => {
    setEditMode(true);
  };
  // const handleSaveClick = () => {
  //   console.log("profileData ", profileData);
  //   // Make API call to save profile changes
  //   fetch(`${process.env.REACT_APP_BACKEND_URL}/profile/`, {
  //     method: "POST",
  //     body: JSON.stringify(profileData),
  //     headers: {
  //       "Content-Type": "application/json",
  //       auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
  //     },
  //   }).then(() => {
  //     // Fetch updated profile data
  //     fetch(`${process.env.REACT_APP_BACKEND_URL}/myprofile/`, {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //         auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
  //       },
  //     })
  //       .then((response) => response.json())
  //       .then((data) => {
  //         // Update profile data in Redux store
  //         dispatch(setProfileData(data));
  //       });
  //   });

  //   // Exit edit mode
  //   setEditMode(false);
  // };

  const handleSaveClick = () => {
    console.log("profileData ", profileData);
    // Make API call to save profile changes
    fetch(`${process.env.REACT_APP_BACKEND_URL}/profile/`, {
      method: "POST",
      body: JSON.stringify(profileData),
      headers: {
        "Content-Type": "application/json",
        auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
      },
    })
      .then(() => {
        // Fetch updated profile data
        fetch(`${process.env.REACT_APP_BACKEND_URL}/myprofile/`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
          },
        })
          .then((response) => response.json())
          .then((data) => {
            // Update profile data in Redux store
            // dispatch(setProfileData(data));
            dispatch(updateProfileData(data));
          })
          .catch((error) => {
            console.error("Error fetching updated profile data:", error);
          });
      })
      .catch((error) => {
        console.error("Error saving profile changes:", error);
      });

    // Exit edit mode
    setEditMode(false);
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setProfileData({ ...profileData, [name]: value });
  };

  return (
    <>
      <div>
        {MyProfile ? (
          <>
            <h1>{profileData.name}</h1>
            <h2>{profileData.address}</h2>
            <h2>{profileData.gst_no}</h2>
            <h2>{profileData.pan_card}</h2>
            <h2>{profileData.phone_no}</h2>
            <h2>{profileData.createdby}</h2>
            {editMode ? (
              <>
                <input
                  type="text"
                  name="name"
                  value={profileData.name}
                  onChange={handleInputChange}
                />
                <br />
                <input
                  type="text"
                  name="address"
                  value={profileData.address}
                  onChange={handleInputChange}
                />
                <br />
                <input
                  type="text"
                  name="gst_no"
                  value={profileData.gst_no}
                  onChange={handleInputChange}
                />
                <br />
                <input
                  type="text"
                  name="pan_card"
                  value={profileData.pan_card}
                  onChange={handleInputChange}
                />
                <br />
                <input
                  type="text"
                  name="phone_no"
                  value={profileData.phone_no}
                  onChange={handleInputChange}
                />
                <br />
                <input
                  type="text"
                  name="createdby"
                  value={profileData.createdby}
                  onChange={handleInputChange}
                />
                <br />
                <button onClick={handleSaveClick}>Save</button>
              </>
            ) : (
              <button onClick={handleEditClick}>Edit</button>
            )}
          </>
        ) : (
          <p>No profile data available.</p>
        )}
      </div>
    </>
  );

  //     <div>
  //       {MyProfile ? (
  //         <>
  //           <h1>{MyProfile?.pro[0]?.name}</h1>
  //           <h2>{MyProfile?.pro[0]?.address}</h2>
  //           <h2>{MyProfile?.pro[0]?.gst_no}</h2>
  //           <h2>{MyProfile?.pro[0]?.pan_card}</h2>
  //           <h2>{MyProfile?.pro[0]?.phone_no}</h2>
  //           <h2>{MyProfile?.pro[0]?.createdby}</h2>
  //         </>
  //       ) : (
  //         <p>No profile data available.</p>
  //       )}
  //     </div>
  //   );
};

export default ShowProfile;
